module.exports = __webpack_public_path__ + "img/向上调节.2aa80193.png";